import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { db } from "../../lib/firebaseCompat";

import CardSearchTable from "../shared/CardSearchTable";
import UserTr from "./UserTr";
import AdminOnly from "../shared/AdminOnly";

import { useTooltip } from "../../hooks/useTooltip";
import { useOrganization } from "../../hooks/useOrganization";
import { useAuth } from "../../hooks/usehooks.com/use-auth";

const AddUserLink = () => {
  const tooltipRef = useTooltip();
  return (
    <AdminOnly>
      <Link to="/user/new">
        <i
          className="material-icons black-text"
          data-tooltip="Add New User to current Organization"
          data-position="left"
          ref={tooltipRef}
        >
          add_circle
        </i>
      </Link>
    </AdminOnly>
  );
};

export default function UsersTable() {
  const auth = useAuth();
  const [searchValue, setSearchValue] = useState("");
  const [users, setUsers] = useState([]);
  const organization = useOrganization();
  const orgName = organization?.current?.name;
  const memberUids = organization?.current?.memberUids;

  const onSubmit = ({ searchUsers }) => {
    setSearchValue(searchUsers);
  };

  useEffect(() => {
    if (!auth.user || !memberUids) return;

    const userRef = db.collection("users");
    const refs = organization.current.memberUids.map((uid) => userRef.doc(uid));

    (async () => {
      const promises = refs.map((ref) => ref.get());
      const docs = await Promise.all(promises);
      const users = docs.map((doc) => ({
        ...doc.data(),
        uid: doc.id,
      }));
      users.sort((a, b) => {
        if (a.uid === auth.user.uid) {
          return -1;
        } else {
          return 1;
        }
      });
      const filteredUsers = users.filter(({ displayName: n = "" }) =>
        n.startsWith(searchValue)
      );
      setUsers(filteredUsers);
    })();
  }, [auth.user, memberUids, searchValue]);

  const Empty = (
    <div>
      No members are viewable for your current organization.
      <a className="btn-small red right" onClick={() => auth.signOut()}>
        Logout
      </a>
    </div>
  );

  return (
    <CardSearchTable
      header={`${orgName} Members`}
      tooltip="A list of the members of your organization."
      placeholder="Search by Member Name"
      empty={Empty}
      searchName="searchUsers"
      onSubmit={onSubmit}
      columns={[
        "name",
        "email",
        "", // logout
        AddUserLink, // edit self or remove from org
      ]}
    >
      {users.map((user, i) => {
        return <UserTr key={i} user={user} />;
      })}
    </CardSearchTable>
  );
}
